import React from "react";
import { ThemeProvider } from "styled-components/native";
import Icon from "react-native-vector-icons/Feather";

import { TokenCheck } from "utils";
import { useSurveyTheme } from "screens/question/hooks";
import { Images } from "utils/Images";
import AppInfo from "screens/main/app-info";
import { MarkdownText, ScrollView } from "components";

import {
  Container,
  BgImage,
  ImageHolder,
  LogoImage,
  TextHolder,
  WelcomeText,
  ButtonHolder,
  StartButton,
  StartText,
  StartImage,
  ErrorMessage,
} from "./styled";

const Main = ({ description, startSurvey, survey }) => {
  const { logo, background, theme } = useSurveyTheme();
  return (
    <ThemeProvider theme={theme}>
      <Container>
        <BgImage source={background} />
        <ImageHolder>
          <LogoImage source={logo} />
        </ImageHolder>
        <TextHolder>
          <ScrollView>
            <WelcomeText>
              <MarkdownText>{description}</MarkdownText>
            </WelcomeText>
          </ScrollView>
        </TextHolder>
        {survey.loading ? (
          <>
            <Icon name="alert-triangle" size={40} color="white" />
            <ErrorMessage>Loading survey</ErrorMessage>
          </>
        ) : survey.error ? (
          <>
            <Icon name="alert-triangle" size={40} color="white" />
            <ErrorMessage>
              Make sure at least one questionnaire is enabled
            </ErrorMessage>
          </>
        ) : (
          <ButtonHolder>
            <StartButton onPress={startSurvey}>
              <StartText>
                {survey.questionnaire.start_button_text || "Ok, start!"}
              </StartText>
              <StartImage
                source={Images.StartRightArrow}
                height="100%"
                width="100%"
              />
            </StartButton>
          </ButtonHolder>
        )}
        <AppInfo />
        <TokenCheck />
      </Container>
    </ThemeProvider>
  );
};

export default Main;
